import React from 'react';

import svg from './assets/icons-16-arrow-back.svg';
import type { IconProps } from './SvgIcon';
import { SvgIcon } from './SvgIcon';

export const IconArrowBack = (props: IconProps) => (
  <SvgIcon {...props} src={svg} testId="icon-arrow-back" />
);
